import {
  get,
  set,
} from 'idb-keyval';

const pageInList = function(list, url) {
  const urls = list.map((item) => item.url);
  return urls.includes(url);
};

const filterOutCurrentPage = function(list, url) {
  return list.filter((item) => {
    return item.url !== url;
  });
};

const setPages = async function() {
  let pages = await get('pages');

  if (pages === undefined) {
    pages = {
      history: [],
    };
  }

  if (window.location.pathname !== '/') {
    // keep the list short
    if (pages.history.length > 3) {
      pages.history = pages.history.slice(-3);
    }

    if (pageInList(pages.history, window.location.href) === false) {
      pages.history.push({
        title: document.title,
        url: window.location.href,
      });

      set('pages', pages);
    }
  }
};

const setCourse = async function(o) {
  let courses = await get('courses');

  if (courses === undefined) {
    courses = {
      list: [],
    };
  }

  if (courses.list.length > 3) {
    // keep the list short
    courses.list = courses.list.slice(-3);
  }

  courses.list.push(o);
  set('courses', courses);
};

const courseTemplate = function(o) {
  return `
    <p class="nav-link-personal--title">
    <i class="icon icon-student" aria-hidden="true"></i>Recent Activity</p>
    <div class="nav-link-personal--content">

      <span class="badge badge-light mb-3">
        ${ o.subjectArea }
      </span>

      <p class="cms-plugin cms-plugin-327432">
        <a href="${ o.url }">
        <strong> ${ o.title }</strong></a>
      </p>

      <dl class="d-none d-sm-block">
        <dt>Qualification:</dt>
        <dd> ${ o.qualification } </dd>
        <dt>Location:</dt>
        <dd> ${ o.locations } </dd>
        <dt>Age Group:</dt>
        <dd> ${ o.segment }</dd>
      </dl>
    </div>`;
};

const populateBlock = async function(
    selector = '.nav-link-personal') {
  const els = document.querySelectorAll(selector);

  const courses = await get('courses');

  // if we have courses then show a course
  if (courses) {
    const course = courses.list.slice(-1)[0];

    els.forEach(function(el) {
      el.insertAdjacentHTML('beforeend', courseTemplate(course));
    });
  } else { // if we don't have courses then show a link
    const pages = await get('pages');

    if (pages) {
      const headerTemplate = `
  <p class="nav-link-personal--title">
    <i class="icon icon-student" aria-hidden="true"></i>Recent Activity</p>
    `;

      const filteredLinks = filterOutCurrentPage(
          pages.history, window.location.href);

      const links = filteredLinks.slice(-2);
      const div = document.createElement('div');

      div.insertAdjacentHTML('beforeend', headerTemplate);

      const contentDiv = document.createElement('div');
      contentDiv.classList.add('nav-link-personal--content');

      div.appendChild(contentDiv);

      const list = document.createElement('ul');
      list.classList.add('list-group', 'list-group--var4');
      contentDiv.appendChild(list);

      links.forEach((item) => {
        const para = document.createElement('li');
        para.classList.add('list-group-item');

        const linkElement = document.createElement('a');
        linkElement.textContent = item.title.split('|')[0];
        linkElement.setAttribute('href', item.url);

        const icon = document.createElement('i');
        icon.classList.add('icon', 'icon-right-open');
        linkElement.appendChild(icon);

        para.appendChild(linkElement);
        list.appendChild(para);
      });

      els.forEach(function(el) {
        el.appendChild(div);
      });
    }
  }
  // otherwise don't show anything
};

const personalisation = {
  setPages,
  setCourse,
  populateBlock,
};

export default personalisation;
